import BaseAPI from "./BaseAPI";

const search = async (hidePackage) => {
    const url = `/agentPackages/search`;
    const params = { hidePackage } //array
    try {
        const result = await BaseAPI.post(url, params);
        return result.data;
    } catch (err) {
        throw err;
    }
}

export default {
    search,
}